import H2 from '../Atoms/H2';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Input from '../Atoms/Input';
import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import * as api from '../../api';
import BlueButton from '../Atoms/BlueButton';
import { getRedirectFromParams, storeRedirect, getStoredRedirect, clearStoredRedirect } from '../Utils/redirectUtils';

const Container = styled.div`
`;

const Login = (props) => {

    console.log(props);

    const { i18n } = useTranslation('common');
    const navigate = useNavigate();
    const location = useLocation();
    const [statusMessage, setstatusMessage] = useState('');

    // Check for redirect parameter on mount
    useEffect(() => {
        const redirectUrl = getRedirectFromParams(location.search);
        if (redirectUrl) {
            storeRedirect(redirectUrl);
        }
    }, [location.search]);

    const handleLogin = async (event) => {
        event.preventDefault();

        const email = event.target.elements.email.value;
        const password = event.target.elements.password.value;

        if (email && password) {
            api.Login({email,password}).then(res => {
                // console.log(res);
                if (res.data.status === "OK") {
                    props.refreshUser();
                    
                    // Check for stored redirect first
                    const storedRedirect = getStoredRedirect();
                    if (storedRedirect) {
                        clearStoredRedirect();
                        navigate(storedRedirect);
                    } else if (props.thengotoevent) {
                        navigate('/evenements');
                    } else {
                        if (res.data.redirect) {
                            navigate(res.data.redirect);
                        } else {
                            navigate('/annuaire');
                        }
                    }
                }
            }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data === "incorrect credentials") {
                    console.log("incorrect credentials");
                    setstatusMessage(i18n.language === "fr" ? "Email ou mot de passe invalide." : "Email or password invalid.");
                }
            });
        }
    }

    return (
        <Container>
            <br/>
            <H2>{i18n.language === "fr" ? "CONNECTEZ-VOUS" : "LOGIN"}</H2><br/>
            <form onSubmit={event => handleLogin(event)}>
                <Input required name="email" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Email" : "Email"} type="email" /><br/><br/>
                <Input required name="password" style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Mot de passe" : "Password"} type="password" /><br/><br/>
                <p className="centered" style={{ color: "red" }}>{statusMessage}</p><br/>
                <BlueButton><img src='/img/fleche_blanche.png' alt='' />{i18n.language === "fr" ? "Se connecter" : "Login"}</BlueButton>
                <br/>
                <br/>
                <Link to="/resetpassword" ><span className="linkbutton" style={{color:"#999"}}> {i18n.language === "fr" ? "J'ai oublié mon mot de passe" : "Forgot your password ?"}</span></Link>
            </form>
        </Container>
    );
}

export default Login;
